import axios from 'axios'
import { servers } from '@/helpers'
import store from '@/store'

export const getCommonQuestions = async (data) => {
  const queryString = new URLSearchParams(data)
  let response = await axios.get(`${servers[store.state.auth.server].scores}/api/v1/questions/common?${queryString}`)
  return response.data.items
}

export const getSurveyGroups = async (data) => {
  const queryString = new URLSearchParams(data)
  let response = ''
  if (data === null) {
    response = await axios.get(`${servers[store.state.auth.server].scores}/api/v1/surveys/groups`)
  } else {
    response = await axios.get(`${servers[store.state.auth.server].scores}/api/v1/surveys/groups/id?${queryString}`)
  }

  return response.data.items
}

export const getQuestionAnswers = async (query) => {
  const queryString = new URLSearchParams(query)
  let response = await axios.get(`${servers[store.state.auth.server].scores}/api/v1/questions/answers?${queryString}`)
  return response.data.items
}

export const getSurveys = async () => {
  let response = await axios.get(`${servers[store.state.auth.server].scores}/api/v1/surveys/all`)
  return response.data.items
}

export const getSurveyData = async (query) => {
  const queryString = new URLSearchParams(query)
  let response = await axios.get(`${servers[store.state.auth.server].scores}/api/v1/surveys/meta?${queryString}`)
  return response.data.items
}
